export class Seq {
  constructor(public residues: string) { }
}
